import { Components, Theme } from '@mui/material/styles';

export default function MuiIconButton(theme: Theme): Components['MuiIconButton'] {
  return {
    styleOverrides: {
      root: {
        '&:where(a)': {
          background: 'revert', // This is to prevent the default anchor styling from index.css from affecting icon buttons.
        },
      },
    },
  };
}
